import { useContext, createContext, useState, useEffect } from "react";
import {useSearch} from "../search/SearchProvider";

const ContratosContext = createContext(undefined);

/**
 * COMPONENTE PRINCIPAL
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function ContratosProvider({children}) {

    /**
     * Guardar texto de búsqueda
     */
    const [busqueda, setBusqueda] = useState("");
    /**
     * Contexto : API finder
     */
    const search = useSearch();
    /**
     * Guardar arreglo de contratos
     */
    const [contratos, setContratos] = useState([]);
    /**
     * Sí hay datos en el localstorage se guardan en el estado 'contratos'
     */
    useEffect(() => {

        const contratosLS = JSON.parse(localStorage.getItem("contrato"));

        setContratos(contratosLS);
        const busquedaLS = JSON.parse(localStorage.getItem('searchRequest'));
        setBusqueda(busquedaLS);


    },[search]);

    /**
     * @function handleChangeState
     * @param id identificar el contrato
     * @param newstate nuevo estado del contrato (activo : 1 || 0)
     * @param newPago nueva fecha de último pago
     * @param newhasta nueva fecha de vencimiento
     * @param promesa
     * @todo actualizar fecha de ultimo pago
     */
    function handleChangeState(id, newstate, newPago, newhasta, promesa) {
        /**
         * Eliminar datos en Storage
         */
        localStorage.removeItem('contrato');
        /**
         * Encontrar contrato y cambiar los nuevos datos
         */
        const contratosNew = contratos.find((c) => c.id_contrato === id);
        contratosNew.vigente = newstate;
        contratosNew.ultimo_pago = {
            "fecha_pago": newPago,
        };
        contratosNew.hasta = newhasta;
        contratosNew.promesa = promesa;
        setContratos(contratos.map((c) => {
            if(c.id_contrato === id){
                return contratosNew;
            }else{
                return c;
            }
        }));
        /**
         * Guardar los datos en storage con los datos cambiados
         */
        localStorage.setItem('contrato', JSON.stringify(contratos));
    }

    /**
     * @const cleanContext limpiar los estados del contexto
     */
    const cleanContext = () => {
        setContratos([]);
        setBusqueda("");
    }

    return (
        <ContratosContext.Provider value={{ contratos, setContratos , busqueda, handleChangeState, cleanContext }}>
            {children}
        </ContratosContext.Provider>
    );
}

export const useContratos = () => {
    return useContext(ContratosContext);
}
